import { render, staticRenderFns } from "./ZhuanXue.vue?vue&type=template&id=1dc54d2f&scoped=true"
import script from "./ZhuanXue.vue?vue&type=script&lang=js"
export * from "./ZhuanXue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc54d2f",
  null
  
)

export default component.exports